import isError from 'lodash/isError'
import { toast } from '@styles/toasts'
import { isJSON } from '@utils'
import type { FlowAccumulator } from '../model'

export const handleErrors =
  (handleUnauthorized, handleBanned) => async (acc: FlowAccumulator) => {
    const { error, response, reqConfig, isUnauthorized, isBanned } = acc
    const { shouldShowErrorToast, definedErrorMessage, shouldRedirectToRoot } = reqConfig!

    if (isUnauthorized) {
      await handleUnauthorized({
        shouldRedirectToRoot,
        shouldShowErrorToast,
      })

      return acc
    }

    if (isBanned) {
      await handleBanned()
      return acc
    }

    if (isError(error)) {
      if (shouldShowErrorToast) {
        if (definedErrorMessage) {
          toast({
            title: definedErrorMessage,
          })
        } else {
          toast({
            title: 'Error',
            description: error.message,
          })
        }
      }

      return acc
    }

    if (!response) {
      return acc
    }

    if (response.status >= 400) {
      try {
        const text = await response.text()

        if (response.status === 401) {
          const skipLogout = response.headers.get('X-Skip-Logout')

          if (skipLogout === 'true') {
            return acc
          }
          await handleUnauthorized({
            shouldRedirectToRoot,
            shouldShowErrorToast,
          })

          return acc
        }

        if (isJSON(text)) {
          const error = JSON.parse(text)
          const errorMessage = error.message || 'Unexpected error.'

          acc.error = new Error(errorMessage)

          if (shouldShowErrorToast) {
            if (definedErrorMessage) {
              toast({
                title: definedErrorMessage,
              })
            } else {
              toast({
                title: errorMessage,
              })
            }
          }

          return acc
        }
      } catch (e) {
        acc.error = new Error("Couldn't parse response")

        return acc
      }
    }

    return acc
  }
